import React from 'react';
import { Award, Trophy, FileCheck } from 'lucide-react';
import { profileData } from '../data/mock';

const Achievements = () => {
  const getIcon = (type) => {
    switch (type) {
      case 'Patent':
        return <FileCheck className="w-8 h-8" />;
      case 'Award':
        return <Trophy className="w-8 h-8" />;
      case 'Certification':
        return <Award className="w-8 h-8" />;
      default:
        return <Award className="w-8 h-8" />;
    }
  };

  return (
    <section className="py-24 px-6 bg-gray-50 dark:bg-gray-800/50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16 opacity-0 animate-fadeInUp">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Achievements
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {profileData.achievements.map((achievement, index) => (
            <div
              key={achievement.id}
              className="bg-white dark:bg-gray-900 rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 opacity-0 animate-fadeInUp"
              style={{ animationDelay: `${200 + index * 150}ms` }}
            >
              <div className="flex items-center justify-center w-16 h-16 bg-blue-100 dark:bg-blue-900/30 rounded-2xl mb-6 text-blue-600 dark:text-blue-400 transform group-hover:scale-110 transition-transform duration-300">
                {getIcon(achievement.type)}
              </div>
              <div className="mb-2">
                <span className="inline-block px-3 py-1 bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 rounded-full text-xs font-medium mb-4">
                  {achievement.type}
                </span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-3">
                {achievement.title}
              </h3>
              {achievement.organization && (
                <p className="text-sm text-blue-600 dark:text-blue-400 font-medium mb-3">
                  {achievement.organization}
                </p>
              )}
              <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                {achievement.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Achievements;